/**
 * Dummy data — 제휴 (Partners)
 * API_DOCS: endpoints.partners / endpoints.admin.partners
 *
 * PartnerResponse:
 *   id(int), company_name(string), contact_name(string), phone(string),
 *   email(string), business_type(string?), message(string?),
 *   status(string="pending"|"approved"|"rejected"), created_at(datetime)
 */

const partners = [
  { id: 1, company_name: '해피투어 여행사', contact_name: '김영호', phone: '02-1234-5678', email: 'happy@tour.com', business_type: 'travel_agency', message: '공항 이동 서비스 제휴 희망합니다.', status: 'approved', created_at: '2026-01-10T10:00:00' },
  { id: 2, company_name: '그린필드 골프클럽', contact_name: '박성호', phone: '031-987-6543', email: 'green@golf.com', business_type: 'golf_club', message: '골프장 셔틀 서비스 연계 제안드립니다.', status: 'pending', created_at: '2026-02-15T14:00:00' },
  { id: 3, company_name: '메디컬코리아', contact_name: '이수진', phone: '02-555-7890', email: 'medical@korea.com', business_type: 'medical_tourism', message: '외국인 환자 병원 이동 서비스 협력 요청합니다.', status: 'rejected', created_at: '2026-02-20T09:30:00' },
];

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ── 서비스 (유저용) ── */

/** POST /api/partners/apply */
export const applyPartner = async (data) => {
  await delay(400);
  const partner = {
    id: partners.length + 1,
    company_name: data.company_name,
    contact_name: data.contact_name,
    phone: data.phone,
    email: data.email,
    business_type: data.business_type || null,
    message: data.message || null,
    status: 'pending',
    created_at: new Date().toISOString(),
  };
  partners.push(partner);
  return { message: '제휴 신청이 접수되었습니다' };
};

/** GET /api/partners/me */
export const getPartnerMe = async (params = {}) => {
  await delay(200);
  const found = partners.find((p) => p.email === params.email);
  if (!found) return null;
  return found;
};

/* ── 관리자 ── */

/** GET /api/admin/partners */
export const getAdminPartners = async (params = {}) => {
  await delay(300);
  const page = params.page || 1;
  const size = params.size || 20;
  const start = (page - 1) * size;
  return {
    items: partners.slice(start, start + size),
    total: partners.length,
    page,
    size,
    pages: Math.ceil(partners.length / size),
  };
};

/** PUT /api/admin/partners/:id/status */
export const updateAdminPartnerStatus = async (id, data) => {
  await delay(400);
  const idx = partners.findIndex((p) => p.id === Number(id));
  if (idx === -1) throw new Error('제휴 신청을 찾을 수 없습니다');
  partners[idx].status = data.status;
  return partners[idx];
};
